import { render, staticRenderFns } from "./HkecicPolicyList.vue?vue&type=template&id=10ef83db"
import script from "./HkecicPolicyList.vue?vue&type=script&lang=js"
export * from "./HkecicPolicyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports